import React, { useEffect } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import actions from '../../../../redux/actions';
import { DataTable } from '../../../../ui';
import { colors } from '../../../../theme/tokens';

const money = (amount: number) => (amount === null || amount === undefined ? '—' : `$${Number(amount).toFixed(2)}`);

/* Customer → Profile → Finance: balance and the history of completed cycles */
const Finance: React.FC = () => {
  const dispatch = useDispatch();
  const finance: any[] = useSelector((state: any) => state.userFinance) || [];
  const user = useSelector((state: any) => state.user);

  useEffect(() => {
    dispatch(actions.listOwnFinance());
  }, []);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
      <Box sx={{ border: `1px solid ${colors.dividerBlue}`, borderRadius: 2, p: 2, maxWidth: 260 }}>
        <Typography sx={{ fontSize: 12, color: colors.textGrey }}>Current balance</Typography>
        <Typography sx={{ fontSize: 22, fontWeight: 600, color: colors.titleBlue }}>{money(user.balance)}</Typography>
      </Box>

      <Box>
        <Typography component="h3" sx={{ fontSize: 15, fontWeight: 600, color: colors.titleBlue, mb: 1 }}>Completed cycles history</Typography>
        <DataTable
          rows={finance}
          rowKey={(row: any, i) => `${row.cycleId || row.title}-${i}`}
          pageSize={20}
          emptyText="No completed cycles yet"
          columns={[
            { key: 'title', label: 'Project', render: (row: any) => row.title },
            { key: 'started', label: 'Started on', render: (row: any) => moment(row.cycleStartDate).format('DD.MM.YYYY') },
            { key: 'required', label: 'Required testers', align: 'right', render: (row: any) => row.requiredTesters },
            { key: 'actual', label: 'Actual testers', align: 'right', render: (row: any) => row.acceptedTesters },
            { key: 'original', label: 'Original price (w/o VAT)', align: 'right', render: (row: any) => money(row.originalPrice) },
            { key: 'used', label: 'Used balance', align: 'right', render: (row: any) => money(row.usedBalance) },
            { key: 'paid', label: 'Paid (w/o VAT)', align: 'right', render: (row: any) => money(row.paid) },
            { key: 'refunded', label: 'Refunded', align: 'right', render: (row: any) => money(row.refunded) },
          ]}
        />
      </Box>
    </Box>
  );
};

export default Finance;
